// prettier-ignore
export const firebaseConfig = {
};
